export default __webpack_public_path__ + "static/media/micro_green.fb4eb9cf.svg";